export enum SupersonicFeatureFlags {
    EnableCostCentersFinance = 'enable_costcenters_for_finance',
    CostCenterNameConfiguration = 'cost-center-name-configuration',
    MultiTimecardUnitAndCostcenterDisplay = 'multi-timecard-unit-and-costcenter-display',
    MDCImportTimeCardMigration = 'mdc-migration-import-timecards-component',
    TimecardImportQueueDocumentNotes = 'timecard-import-queue-document-notes',
    TimecardImportQueueNotesInEditModal = 'timecard-import-queue-notes-in-edit-modal',
    ExportPurchaseOrdersGrid = 'export-purchase-orders-grid'
}
